import {
  Box,
  LinearProgress,
  linearProgressClasses,
  styled,
} from "@mui/material";
import { APP_COLOR } from "../../theme";

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 15,
  borderRadius: 10,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 10,
    backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : APP_COLOR,
  },
}));

export const StorageContainer = styled(Box)(({ theme }) => ({
  width: "30%",
  marginLeft: "auto",
  marginRight: "1",
  [theme.breakpoints.down("sm")]: {
    minWidth: "100%",
    marginLeft: "2px",
    marginRight: "2px",
  },
}));

export const styles = {
  usedStorage: {
    width: 10,
    height: 10,
    backgroundColor: APP_COLOR,
    borderRadius: 1,
    marginRight: 1,
  } as const,
  freeStorage: {
    width: 10,
    height: 10,
    backgroundColor: "#424242",
    borderRadius: 1,
    marginRight: 1,
  } as const,
  storageDetail: { marginX: 1, display: "flex", fontSize: 15 } as const,
};
